import { parseDate } from './date-util';

export const dateToIcd10Year = date => {
  let modifier = 0;

  if (Number(parseDate(date).format('MM')) >= 10) modifier = 1;

  return Number(parseDate(date).format('YYYY')) + modifier;
};
